/**
 * Modal Achievement Form Constants
 * Contains all text strings used in the achievement registration modal
 */

export const MODAL_ACHIEVEMENT_FORM = {
  BUTTON_REGISTER: 'Registrar logro',
  CHAPTER_LABEL: 'Chapter',
  CHAPTER_SELECT_TITLE: 'Selecciona el chapter',
  CHAPTER_FIELD_DESCRIPTION: 'El líder del chapter seleccionado aprobará tu logro',
  ACHIEVEMENT_TYPE_LABEL: 'Tipo de logro',
  ACHIEVEMENT_TYPE_SELECT_TITLE: 'Selecciona el logro',
  ACHIEVEMENT_TYPE_CHAPTER_DEFINITION_PREFIX: 'Definición del chapter',
  NAME_LABEL: 'Nombre logro realizado',
  NAME_PLACEHOLDER: 'Escriba el evento que llevó a cabo el pragmático',
  DATE_LABEL: 'Fecha logro',
  DATE_FORMAT_DESCRIPTION: 'Escribe el formato día/mes/año',
  COMMENT_LABEL: 'Agregar comentario adicional',
  COMMENT_PLACEHOLDER: 'Escribe aquí tu comentario',
  COMMENT_COUNTER_SUFFIX: '/ 1000',
  EVIDENCE_LABEL: 'Añade link de evidencia',
  EVIDENCE_PLACEHOLDER: 'Pega aquí el link a la charla, vídeo, tutorial...',
  EVIDENCE_ERROR_MESSAGE: 'Ingresa una URL válida. Ejemplo: https://example.com',
};
